import React from 'react';
import { zendesk } from '@marvelapp/help';
import { Button, Message, Text } from '@marvelapp/ui';
export default function CodeError(_a) {
    var lang = _a.lang;
    return (React.createElement(Message, { kind: "error" },
        React.createElement(Text, { fontSize: 13 },
            "Oops! Looks like there was an error loading the ",
            lang,
            ". Please try uploading your screen again or contact support.",
            React.createElement(Button, { as: "a", href: zendesk.NEW_TICKET, kind: "ghost", marginTop: 2, rel: "noopener noreferrer", target: "_blank" }, "Contact support"))));
}
